
// ** Initial State
const initialState = {
    referralCodes: []
}

export function referrals(state = initialState, action) {
    switch (action.type) {


        default:
            return state
    }
}

export default referrals
